module.exports = __webpack_public_path__ + "img/bronze.9eac3a2f.png";